/**
 * Testimonials data for Home page
 */
const ligaLogo = "/images/clients/lese-CNc1h715.png";
const pcisLogo = "/images/clients/pcis.PNG";
const cuickLogo = "/images/clients/cuick-logo.png";
const bajaPointLogo = "/images/clients/baja-point.png";

export const getTestimonials = (t) => [
  {
    name: "Juan F. Cossio",
    role: t("home.testimonials.testimonial1.role"),
    rating: 5,
    comment: t("home.testimonials.testimonial1.comment"),
    avatar: "J",
    company: "Liga Empresarial",
    companyUrl: "https://ligaempresarialsoftbolen-28a1e.web.app/",
    companyLogo: ligaLogo,
    verified: true,
  },
  {
    name: "Jesus Martínez",
    role: t("home.testimonials.testimonial3.role"),
    rating: 5,
    comment: t("home.testimonials.testimonial3.comment"),
    avatar: "J",
    company: "PCIS",
    companyUrl: "https://pcis-web-ens.web.app/es",
    companyLogo: pcisLogo,
    verified: true,
  },
  {
    name: "Jaime Herrera",
    role: t("home.testimonials.testimonial4.role"),
    rating: 5,
    comment: t("home.testimonials.testimonial4.comment"),
    avatar: "J",
    company: "Cuick Hamburguesas",
    companyUrl: "https://cuick-web.web.app/",
    companyLogo: cuickLogo,
    verified: true,
  },
  {
    name: "Alfredo Castellanos",
    role: t("home.testimonials.testimonial5.role"),
    rating: 5,
    comment: t("home.testimonials.testimonial5.comment"),
    avatar: "A",
    company: "Baja Point",
    companyUrl: "https://baja-point.web.app/",
    companyLogo: bajaPointLogo,
    verified: true,
  },
];
